import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import LoginForm from '../../Components/LoginForm/LoginForm';
import { useUserContext } from '../../core/context/user.context';

function Login() {
  const { user } = useUserContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (user.email) navigate('/');
  }, [user]);

  return (
    <section>
      <div className="wrap">
        <div className="form-container">
          <LoginForm />
        </div>
      </div>
    </section>
  );
}

export default Login;
